import {
	Component,
	OnInit,
	Inject,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	TemplateRef,
} from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import {
	NgbDate,
	NgbCalendar,
	NgbDateParserFormatter,
	NgbModal,
} from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { User } from '../../core/models/user';
// import { LeadsService } from "src/app/pages/crm/leads/leads.service";
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { getFirebaseBackend } from 'src/app/authUtils';
import { CampaignService } from '../../services/campaigns/campaign.service';
import { BillingService } from '../../services/billing/billing.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
	selector: 'app-billing',
	templateUrl: './billing.component.html',
	styleUrls: ['./billing.component.scss'],
})
export class BillingComponent implements OnInit {
	@Input() stripe_back: string = '';
	@Input() alertedIn: boolean = false;
	@Output() alerted = new EventEmitter<boolean>();

	@ViewChild('tableUnpaid') tableUnpaid: DatatableComponent;
	@ViewChild('numLead') numLead: ElementRef;
	@ViewChild('agent') agent: ElementRef;
	@ViewChild('alias') alias: ElementRef;
	@ViewChild('prospect') prospect: ElementRef;
	@ViewChild('campaign') campaign: ElementRef;
	@ViewChild('tablePaid') tablePaid: DatatableComponent;
	@ViewChild('numLeadP') numLeadP: ElementRef;
	@ViewChild('agentP') agentP: ElementRef;
	@ViewChild('aliasP') aliasP: ElementRef;
	@ViewChild('prospectP') prospectP: ElementRef;
	@ViewChild('campaignP') campaignP: ElementRef;
	@ViewChild('AmountP') AmountP: ElementRef;

	user: User = null;
	fromDate: NgbDate | null;
	toDate: NgbDate | null;
	campaigns = [];
	showPayed: boolean = false;
	showInactiveCampaigns: boolean = false;
	loading = false;
	approved = [];
	notPayedLeads = [];
	searchCampaign = 'All';
	hoveredDate: NgbDate | null = null;
	selectedLead: any;
	prices: any[];
	selectedCost: string;
	loadingPrices: boolean;
	loadingCharge: boolean;

	//Table
	columnMode = ColumnMode;
	rowsUnpayed = [];
	rowsPayeds = [];
	SearchUnpayed = [];
	SearchPaid = [];

	constructor(
		private router: Router,
		private dataService: OldDataService,
		public authenticationService: AuthenticationService,
		private userSrv: UserService,
		private calendar: NgbCalendar,
		private modalService: NgbModal,
		public formatter: NgbDateParserFormatter,
		public utils: UtilsService,
		private campaignSrv: CampaignService,
		private billingSrv: BillingService
		// private leadsService: LeadsService,
	) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.fromDate = calendar.getToday();
		this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 10);
		this.toDate = calendar.getToday();
		this.selectedCost = null;
		this.loadingPrices = false;
		this.loadingCharge = false;
	}

	ngOnInit() {
		switch (this.stripe_back) {
			case 'cancel':
				if (!this.alertedIn) {
					Swal.fire({
						title: 'Card verification canceled',
						text: '',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					}).then((data) => {
						this.stripe_back = '';
						this.alerted.emit(true);
					});
				}
				break;
			case 'success':
				if (!this.alertedIn) {
					Swal.fire({
						title: 'Card verification success',
						text: '',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					}).then((data) => {
						this.alerted.emit(true);
					});
				}

				break;

			default:
				break;
		}
	}



	getAllApproved() {
		this.showPayed = false;
		this.loading = true;


		this.billingSrv.getNotPayedLeads().subscribe((data: any)=>{
			this.notPayedLeads = data.body;
			this.loading = false;
		});

		// this.dataService
		// 	.post(url, { order_by: 'lead_creation', asc_desc: 'ASC' })
		// 	.then((data) => {
		// 		if (data) {
		// 			if (data.records && data.records.length && !data.error) {
		// 				this.approved = [];
		// 				for (let lead of data.records) {
		// 					this.approved.push(lead);
		// 				}
		// 				this.notPayedLeads = this.approved.filter(
		// 					(lead) => lead.payed === 'F' || lead.payed === 'P',
		// 				);
		// 				this.rowsUnpayed = this.notPayedLeads;
		// 				this.SearchUnpayed = this.rowsUnpayed;
		// 				this.loading = false;
		// 			} else if (data.error) {
		// 				if (data.status && data.status === 401) {
		// 					// this.authenticationService.logout("------GetAllApproved");
		// 					location.reload();
		// 					this.loading = false;
		// 				}
		// 			} else {
		// 				this.loading = false;
		// 			}
		// 		} else {
		// 			this.loading = false;
		// 		}
		// 	});
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate &&
			!this.toDate &&
			this.hoveredDate &&
			date.after(this.fromDate) &&
			date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return (
			this.toDate && date.after(this.fromDate) && date.before(this.toDate)
		);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

	validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed))
			? NgbDate.from(parsed)
			: currentValue;
	}



	datePickerToPHP(date) {
		let mes = '';
		let dia = '';

		if (date.month < 10) {
			mes = '0' + date.month;
		} else {
			mes = date.month;
		}

		if (date.day < 10) {
			dia = '0' + date.day;
		} else {
			dia = date.day;
		}
		return date.year + '-' + mes + '-' + dia;
	}

	editCampaign(id) {
		this.router.navigate(['/campaign-edit'], {
			queryParams: { id: id, from: 'billing' },
		});
	}

	updateFilter(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.rowsUnpayed;
		} else {
			searchWithFilters = this.SearchUnpayed;
		}
		switch (opcion) {
			case 1: //id
				answer_filter = searchWithFilters.filter(function (d) {
					return d.id.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //generated_by
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.generated_by.toLowerCase().indexOf(val) !== -1 || !val
					);
				});

				break;
			case 3: //alias
				answer_filter = searchWithFilters.filter(function (d) {
					return d.alias.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 4: //prospect_company
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.prospect_company.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});

				break;
			case 5: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.campaign_name.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});
			default:
				break;
		}

		this.rowsUnpayed = answer_filter;
		this.tableUnpaid.offset = 0;
	}

	cleanFiltersSearch() {
		this.numLead.nativeElement.value = '';
		this.agent.nativeElement.value = '';
		this.alias.nativeElement.value = '';
		this.prospect.nativeElement.value = '';
		this.campaign.nativeElement.value = '';

		this.rowsUnpayed = this.SearchUnpayed;
	}

	updateFilterP(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.rowsPayeds;
		} else {
			searchWithFilters = this.SearchPaid;
		}

		switch (opcion) {
			case 1: //id
				answer_filter = searchWithFilters.filter(function (d) {
					return d.id.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //generated_by
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.generated_by.toLowerCase().indexOf(val) !== -1 || !val
					);
				});

				break;
			case 3: //alias
				answer_filter = searchWithFilters.filter(function (d) {
					return d.alias.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 4: //prospect_company
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.prospect_company.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});

				break;
			case 5: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return (
						d.campaign_name.toLowerCase().indexOf(val) !== -1 ||
						!val
					);
				});

				break;
			case 6: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return d.amount.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			default:
				break;
		}

		this.rowsPayeds = answer_filter;
		this.tablePaid.offset = 0;
	}

	cleanFiltersSearchP() {
		this.numLeadP.nativeElement.value = '';
		this.agentP.nativeElement.value = '';
		this.aliasP.nativeElement.value = '';
		this.prospectP.nativeElement.value = '';
		this.campaignP.nativeElement.value = '';
		this.AmountP.nativeElement.value = '';



		// this.rowsPayeds=this.SearchPaid;
	}




}
